import AuthenticationContext from 'adal-angular'

const config = {
  tenant: process.env.VUE_APP_TENANT,
  clientId: process.env.VUE_APP_CLIENTID,
  redirectUri: process.env.VUE_APP_REDIRECTURI,
  cacheLocation: 'sessionStorage',
} as AuthenticationContext.Options

var authenticationContext = new AuthenticationContext(config)
export default {
  /**
   * @return {Promise}
   */
  initialize(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
        // redirect to the location specified in the url params.
        authenticationContext.handleWindowCallback()
      } else {
        // try pull the user out of local storage
        let user = authenticationContext.getCachedUser()

        if (user) {
          resolve()
        } else {
          // no user at all - go sign in.
          this.signIn()
        }
      }
    })
  },
  /**
   * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
   */
  acquireToken(resource: any): Promise<string> {
    return new Promise((resolve, reject) => {
      authenticationContext.acquireToken(resource, (error, token) => {
        if (error || !token) {
          // this can happen when user agent has an ad blocker
          if (error && error.split(':')[0] == 'AADSTS50058') {
            authenticationContext.login()
          }
          return reject(error)
        } else {
          return resolve(token)
        }
      })
    })
  },
  /**
   * Issue an interactive authentication request for the current user and the api resource.
   */
  acquireTokenRedirect(resource: any) {
    authenticationContext.acquireTokenRedirect(resource)
  },
  /**
   * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
   */
  isAuthenticated(): boolean {
    // getCachedToken will only return a valid, non-expired token.
    if (authenticationContext.getCachedToken(config.clientId)) {
      return true
    }
    return false
  },
  /**
   * @return An ADAL user profile object.
   */
  getUserProfile() {
    return authenticationContext.getCachedUser().profile
  },
  signIn() {
    authenticationContext.login()
  },
  signOut() {
    authenticationContext.logOut()
  },
  checkRoles(roles: any) {
    if (!this.isAuthenticated()) {
      return false
    }
    if (!this.getUserProfile().roles) {
      return false
    }
    if (typeof roles === 'string') {
      roles = [roles]
    }

    for (let i = 0; i < roles.length; i++) {
      if (this.getUserProfile().roles.indexOf(roles[i]) > -1) {
        return true
      }
    }

    return false
  },
}
